export const CENTRALE_SANS_BOLD = 'CentraleSans Bold';
export const CENTRALE_SANS_BOOK = 'CentraleSans Book';
